import * as React from 'react'
import { connect } from 'react-redux'
import * as Types from 'DVWebNodeWpsRuntime'
import { QueryParameters } from 'DVWebNodeUtils'
import { Link } from '@amzn/dvui/dist/Link'
import { TextLocalizer } from '../localizer/localizer'
import { buildDetailPageUrl, buildSignInUrl } from '../../utils/url'
import { IDetailPageState } from '../../reducers'
import { IRequestContext } from '../../selectors/requestContext'
import { shouldShowMoreWaysToWatch } from '../morePurchaseOptions/btfMorePurchaseOptions'
import { redeemAndPromoComponentSelector } from '../../selectors/component/actionBoxComponentSelectors'
import { CloseModal } from '@shared/utils/modalTrigger/ModalTrigger'
import { GiftCardButton } from '../giftCard/giftCardModal'
import * as st from './redeemAndPromoLink.module.scss'
import { AtfTreatmentProps } from '../../reducers/features'
import * as cn from 'classnames'
import { isTreatment } from '../../utils/utils'

export interface IRedeemAndPromoLinkProps {
  placement: 'MWTW' | 'ActionBox'
  closeModal?: CloseModal
  toggleGiftCardModal?: () => void
}

export interface IUnrecognizedLink {
  parameters: QueryParameters
  originalURI: string
  titleID: string
  isRetail: boolean
}

type IStateProps = {
  isRedeemAndPromoRestricted: boolean
  hasTvodWinnerOffer: boolean
  moreWaysToWatch?: Types.atv.wps.AcquisitionActionTreeModelProps
  titleID: string
  requestContext: IRequestContext
}

const UnrecognizedLink = ({
  titleID,
  parameters,
  originalURI,
  isRetail
}: IUnrecognizedLink) => {
  const dpUrl = buildDetailPageUrl(
    { parameters, originalURI, isRetail },
    titleID,
    'dv_dp_gc_sign_in'
  )
  const signInUrl = buildSignInUrl(
    { parameters, originalURI, isRetail },
    'dv_dp_gc_sign_in',
    dpUrl
  )
  return (
    <Link href={signInUrl}>
      <TextLocalizer
        stringID='AVOD_DP_redeem_gift_card_or_promotion'
      />
    </Link>
  )
}

export const ConnectedRedeemAndPromoLink = ({
  isRedeemAndPromoRestricted,
  hasTvodWinnerOffer,
  titleID,
  moreWaysToWatch,
  placement,
  closeModal,
  requestContext: {
    isRecognizedCustomer,
    queryParameters,
    originalURI,
    isRetail
  },
  toggleGiftCardModal,
  atfTreatment
}: IRedeemAndPromoLinkProps & IStateProps & AtfTreatmentProps) => {
  // No Redeem Gift Card and Promo popup when
  // - DP rendered in the Windows App
  // - DP Rendered on primevideo.com
  // - it is restricted
  // - Link is already in the MoreWaysToWatch popup
  const doNotRenderPromoLink =
    global.__NATIVEAPP__
    || !isRetail
    || isRedeemAndPromoRestricted
    || placement === 'ActionBox' && (!hasTvodWinnerOffer || shouldShowMoreWaysToWatch(moreWaysToWatch))

    if (doNotRenderPromoLink) {
    return null
  }

  return (
    <div className={cn(st.redeemAndPromoLink, 'dv-gift-card-wrapper', {[st.centerLink]: isTreatment(atfTreatment, 'T1', 'T2', 'T3')})}>
      { isRecognizedCustomer ? <GiftCardButton openModal={() => combine(closeModal, toggleGiftCardModal)}/>
                             : <UnrecognizedLink titleID={titleID}
                                                parameters={queryParameters}
                                                originalURI={originalURI}
                                                isRetail={isRetail} />
      }
    </div>
  )
}

const combine = (...functions: (() => any)[]) => {
  functions.forEach(f => f && f())
}

const mapStateToProps = (state: IDetailPageState): IStateProps => redeemAndPromoComponentSelector(state)

export const RedeemAndPromoLink = connect(mapStateToProps)(
  ConnectedRedeemAndPromoLink
)
